// extracted by mini-css-extract-plugin
export default {"postPage":"mFmpGg","emptyState":"vkmZxG","recentPosts":"EfqCvP"};